export enum AccountRelationAssignmentOption {
  assigned = 1,
  notAssigned = 2,
}